import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import axios from 'axios';
import * as Yup from 'yup';
import {
  AppDatePicker,
  AppSingleSelect,
  AppTextArea,
} from '@/layout/AppComponents';
import { axiosPath } from '../../../../../../routing/helpers/router';
import useIsMounted from '../../../../../components/hooks/useIsMounted';
import errorHandler from '@/layout/components/error/ErrorHandler';

export default function InecoRiskManagerRiskGoalForm({
  riskID,
  goalID,
  kpiTab,
  onShowDeleteGoalModal,
  onCloseModals,
  onReloadTab,
}) {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const moduleData = useSelector(
    (s) => s?.module?.[moduleBridgeHex]?.moduleData
  );
  const validationSchema = Yup.object().shape({
    description: Yup.string().required('Requerido'),
  });

  // > SAVE
  const handleSave = useCallback(
    async (values) =>
      axios
        .post(
          axiosPath(
            goalID === 0
              ? "api_r_user_module_inecoRiskManager_risk_goal_add"
              : "api_r_user_module_inecoRiskManager_risk_goal_edit"
          ),
          {
            moduleBridgeHex,
            riskID,
            goalID,
            ...values,
          }
        )
        .then(() => {
          if (isMounted.current) {
            onCloseModals();
            onReloadTab();
          }
        })
        .catch((e) => dispatch(errorHandler(e))),
    [moduleBridgeHex, riskID, goalID]
  );
  // < SAVE

  return (
    <Formik
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={validationSchema}
      initialValues={{
        description:
          kpiTab?.find((g) => g?.id === goalID)?.description || '',
      }}
      onSubmit={handleSave}
    >
      {({ setFieldValue, handleSubmit, values, errors, isSubmitting }) => (
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-12">
              <AppTextArea
                title="Descripción"
                onChange={(v) => setFieldValue('description', v)}
                value={values.description}
                error={errors.description}
                resize
                height="240px"
                isClearable
              />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-12">
              <button
                type="submit"
                className="btn btn-sm btn-success float-right"
                disabled={isSubmitting}
              >
                {goalID !== 0 ? 'Editar' : 'Crear'}
              </button>
              {goalID !== 0 && (
                <button
                  type="button"
                  className="btn btn-sm btn-danger float-right mr-2"
                  onClick={() => onShowDeleteGoalModal(goalID)}
                >
                  Eliminar
                </button>
              )}
              <button
                type="button"
                className="btn btn-sm btn-outline-danger float-right mr-2"
                onClick={onCloseModals}
              >
                Cancelar
              </button>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}
